import React from "react";
import "./RightSide.css";
import CustomerReview from "../Stats/CustomerReview/CustomerReview";

const RightSide = () => {
  return (
    <div className="RightSide">
      <h3 className="RightSide-title">Avis Clients</h3>
      <CustomerReview />
    </div>
  );
};

export default RightSide;
